import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import models from '@/model';
import { getLocale } from '@/utils';

export const fetchBingoGames = (context: LogicContext) => async () => {
  const { status, data } = await models.fetchBingoGames({
    locale: getLocale(config),
    market_country: config.viewer_country,
    market_region: config.viewer_region,
  });

  return {
    status,
    bingoGames: data,
  };
};
